import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { RouteNotFound } from 'components/404'
import { AS2ConnectionConfigs } from './ConnectionConfigs/AS2ConnectionConfig'
import { CONNECTION_CONFIG_TYPES } from './ConnectionConfigs/ConnectionConfigTypes'
import { InboundConnectionConfigs } from './ConnectionConfigs/InboundConnectionConfig'
import { OutboundConnectionConfigs } from './ConnectionConfigs/OutboundConnectionConfig'
import { EdiFileDetails } from './EdiFileDetails'
import { Documentation } from './EdiSelfService/Documentation/Document/Documentation'
import { EdiSelfService } from './EdiSelfService/EdiSelfService'
import { EdiSelfServiceOutbound } from './EdiSelfServiceOutbound'
import { FilesTable } from './FilesTable'
import { FilesTableMapper } from './FilesTableMapper'
import { InboundFileRouterConfigs } from './InboundFileRouterConfigs/InboundFileRouterConfigs'
import { EDI_TOOLS_ROUTES } from './LandingPage'
import { RawEdiFileDetails } from './RawEdiFileDetails'
import { ShipperConfigContacts } from './ShipperConfigDetails/Overview/ShipperConfigContacts'
import { ShipperConfigDetails } from './ShipperConfigDetails/ShipperConfigDetails'
import { ShipperConfigList } from './ShipperConfigDetails/ShipperConfigList'

export const APP_NAME = 'edi-tools'

export function LandingPageContent() {
  return (
    <Switch>
      <Route exact path='/'>
        <Redirect to={EDI_TOOLS_ROUTES.MAPPER_FILES} />
      </Route>
      <Route exact path={EDI_TOOLS_ROUTES.MAPPER_FILES}>
        <FilesTableMapper />
      </Route>
      <Route exact path={EDI_TOOLS_ROUTES.RAW_EDI_FILES_DETAILS}>
        <RawEdiFileDetails />
      </Route>
      <Route exact path={EDI_TOOLS_ROUTES.SHIPPER_CONFIG}>
        <ShipperConfigList />
      </Route>
      <Route
        exact
        path={[
          `${EDI_TOOLS_ROUTES.SHIPPER_CONFIG}/:id/shipperName/:name`,
          `${EDI_TOOLS_ROUTES.SHIPPER_CONFIG}/:id/shipperName/:name/inboundConfigId/:configId`,
          `${EDI_TOOLS_ROUTES.SHIPPER_CONFIG}/:id/shipperName/:name/outboundConfigId/:configId`,
          `${EDI_TOOLS_ROUTES.SHIPPER_CONFIG}/:id/shipperName/:name/parserId/:parserId`,
          `${EDI_TOOLS_ROUTES.SHIPPER_CONFIG}/:id/shipperName/:name/builderId/:builderId`,
        ]}>
        <ShipperConfigDetails />
      </Route>
      <Route
        exact
        path={`${EDI_TOOLS_ROUTES.SHIPPER_CONFIG}/:id${EDI_TOOLS_ROUTES.SHIPPER_CONTACTS}`}>
        <ShipperConfigContacts />
      </Route>
      <Route
        exact
        path={[
          EDI_TOOLS_ROUTES.SELF_SERVE_INBOUND,
          `${EDI_TOOLS_ROUTES.SELF_SERVE_INBOUND}/parser-version/:parserVersionId`,
          `${EDI_TOOLS_ROUTES.SELF_SERVE_INBOUND}/parser-version/:parserVersionId/parser-test/:parserTestId`,
        ]}>
        <EdiSelfService />
      </Route>
      <Route
        exact
        path={[
          EDI_TOOLS_ROUTES.SELF_SERVE_OUTBOUND,
          `${EDI_TOOLS_ROUTES.SELF_SERVE_OUTBOUND}/builder/:builderId`,
          `${EDI_TOOLS_ROUTES.SELF_SERVE_OUTBOUND}/builder/:builderId/builder-version/:builderVersionId`,
        ]}>
        <EdiSelfServiceOutbound />
      </Route>
      <Route exact path={EDI_TOOLS_ROUTES.SELF_SERVE_INBOUND_DOCUMENTATION}>
        <Documentation />
      </Route>
      <Route
        exact
        path={[
          `/connection-configs/${CONNECTION_CONFIG_TYPES.as2}`,
          `/connection-configs/${CONNECTION_CONFIG_TYPES.as2}/:id`,
        ]}>
        <AS2ConnectionConfigs />
      </Route>
      <Route
        exact
        path={[
          `/connection-configs/${CONNECTION_CONFIG_TYPES.inbound}`,
          `/connection-configs/${CONNECTION_CONFIG_TYPES.inbound}/:configId`,
        ]}>
        <InboundConnectionConfigs />
      </Route>
      <Route
        exact
        path={[
          `/connection-configs/${CONNECTION_CONFIG_TYPES.outbound}`,
          `/connection-configs/${CONNECTION_CONFIG_TYPES.outbound}/:configId`,
        ]}>
        <OutboundConnectionConfigs />
      </Route>
      <Route
        exact
        path={[
          EDI_TOOLS_ROUTES.FILE_ROUTING_CONFIGS,
          `${EDI_TOOLS_ROUTES.FILE_ROUTING_CONFIGS}/:id`,
        ]}>
        <InboundFileRouterConfigs />
      </Route>
      <Route exact path='/worker-files/'>
        <FilesTable />
      </Route>
      <Route exact path='/worker-files/:id/details'>
        <EdiFileDetails />
      </Route>
      <Route>
        <RouteNotFound />
      </Route>
    </Switch>
  )
}
